import { render, staticRenderFns } from "./product.page.vue?vue&type=template&id=7a0c32a2&scoped=true&"
import script from "./product.page.vue?vue&type=script&lang=ts&"
export * from "./product.page.vue?vue&type=script&lang=ts&"
import style0 from "./product.page.vue?vue&type=style&index=0&id=7a0c32a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c32a2",
  null
  
)

export default component.exports